import { render, staticRenderFns } from "./MobilePhoneNumberInput.vue?vue&type=template&id=a50400d4&scoped=true"
import script from "./MobilePhoneNumberInput.vue?vue&type=script&lang=ts"
export * from "./MobilePhoneNumberInput.vue?vue&type=script&lang=ts"
import style0 from "./MobilePhoneNumberInput.vue?vue&type=style&index=0&id=a50400d4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50400d4",
  null
  
)

export default component.exports